import PropTypes from 'prop-types'
import React from 'react'
import { CloseIcon } from '../../assets/icons/CloseIcon'
import { BUTTON_STYLE_BLUE } from '../../libraries/ButtonTheme'
import { getMergedClassNames } from '../../utils/HTMLutils'
import Button from '../button/Button'
import IconButton from '../iconButton/IconButton'
import './NotaEdit.scss'
const rootClassName = 'component-nota-edit'

export default function NotaEdit(props) {
  return (
    <div className={rootClassName}>
      <div className={`${rootClassName}-titulo`}>
        <input
          {...props.inputTitleProps}
          className={getMergedClassNames([
            props.inputTitleProps && props.inputTitleProps.className
              ? props.inputTitleProps.className
              : '',
            'scroll-white',
            'nunito'
          ])}
        />
      </div>
      <div className={`${rootClassName}-texto`}>
        <textarea
          {...props.inputTextProps}
          className={getMergedClassNames([
            props.inputTextProps && props.inputTextProps.className
              ? props.inputTextProps.className
              : '',
            'scroll-white',
            'nunito'
          ])}
        />
      </div>
      {!props.hideCloseButton ? (
        <div className={`${rootClassName}-close-button`}>
          <IconButton
            theme={props.iconButtonTheme}
            icon={<CloseIcon />}
            onClick={() => {
              if (typeof props.onClose === 'function') {
                props.onClose()
              }
            }}
          />
        </div>
      ) : undefined}
      <div className={`${rootClassName}-save-button`}>
        <Button theme={BUTTON_STYLE_BLUE} {...props.buttonSaveProps}>
          {props.buttonSaveProps ? props.buttonSaveProps.label : ''}
        </Button>
      </div>
    </div>
  )
}

NotaEdit.propTypes = {
  inputTitleProps: PropTypes.shape({
    PlaceHolder: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onChange: PropTypes.func,
    maxLength: PropTypes.number
  }),
  inputTextProps: PropTypes.shape({
    PlaceHolder: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onChange: PropTypes.func,
    maxLength: PropTypes.number
  }),
  buttonSaveProps: PropTypes.shape({
    label: PropTypes.string,
    onClick: PropTypes.func
  }),
  onClose: PropTypes.func,
  hideCloseButton: PropTypes.bool,
  iconButtonTheme: PropTypes.string
}

NotaEdit.defaultProps = {
  iconButtonTheme: 'blue'
}
